<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 mb-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Allgemein') }}</legend>
                            <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />
                            <text-input label="Name" v-model="form.name" :error="form.errors.name" />
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Misc') }}</legend>
                            <text-input type="number" label="sort_order" v-model="form.sort_order" :error="form.errors.sort_order" />
                        </fieldset>
                    </div>
                </div>
            </div>

        </div>

        <div class="d-flex align-items-center w-100">
            <submit-button :form="form" />
        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'paymentMethod',
            'taxCalcModeOptions',
        ],
        data() {
            return {
            }
        },
        components: {
            TextInput,
            PriceInput,
            PercentInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            addOption() {

                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                const option = {
                };
                this.form.options.push(option);
            },
            cloneOption(index) {
                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                let cloned = JSON.parse(JSON.stringify(this.form.options[index]));
                this.form.options.push(cloned);
            },
        },
    }
</script>
